"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var encrypt_1 = require("./encrypt");
var exceptions_1 = __importDefault(require("./exceptions"));
var storage_1 = __importDefault(require("./storage/storage"));
var Cella = /** @class */ (function () {
    function Cella(props) {
        var _this = this;
        var _a, _b;
        this.transforms = [];
        this.defaultStorage = storage_1.default.localStorage;
        this.store = function (_a) {
            var key = _a.key, value = _a.value;
            if (!key || !key.length)
                throw exceptions_1.default.nullKey;
            // if(localStorage.getItem(key)) throw exceptions.keyExists
            // execute inbound transforms if any
            if (_this.transforms.length) {
                _this.transforms.forEach(function (t) {
                    value = t.inbound(value);
                });
            }
            // ensure value is most defnitely a string
            if (!value)
                value = '';
            else
                value = JSON.stringify(value);
            // apply encryption if any
            if (_this.encrypt) {
                if (!_this.encrypt.secret || !_this.encrypt.secret.length)
                    throw exceptions_1.default.nullSecretKey;
                value = encrypt_1.applyEncrypt(value, _this.encrypt.secret);
            }
            _this.storage.store(key, value);
        };
        this.get = function (_a) {
            var _b;
            var key = _a.key;
            if (!key || !key.length)
                throw exceptions_1.default.nullKey;
            var value = (_b = _this.storage.get(key)) !== null && _b !== void 0 ? _b : '';
            // apply decryption if any
            if (_this.encrypt) {
                if (!_this.encrypt.secret || !_this.encrypt.secret.length)
                    throw exceptions_1.default.nullSecretKey;
                value = encrypt_1.applyDecrypt(value, _this.encrypt.secret);
            }
            // parse json
            if (value.length) {
                try {
                    value = JSON.parse(value);
                }
                catch (_c) {
                    // parsing from json will fail if
                    // retrieved value is an 8byte (is that what crypto-js said?) encrypted item
                    throw exceptions_1.default.retrievingUndecryptedItem;
                }
            }
            // execute outbound transforms if any
            if (_this.transforms.length) {
                _this.transforms.forEach(function (t) {
                    value = t.outbound(value);
                });
            }
            return value;
        };
        this.eject = function (_a) {
            var key = _a.key;
            if (!key || !key.length)
                throw exceptions_1.default.nullKey;
            _this.storage.eject(key);
        };
        // determine storage engine
        if (props === null || props === void 0 ? void 0 : props.storage) {
            // type check probably not required.
            if (typeof (props === null || props === void 0 ? void 0 : props.storage) == 'object' && 'type' in (props === null || props === void 0 ? void 0 : props.storage)) {
                var selectedEngine = props.storage;
                if (selectedEngine.type == 'indexedDB') {
                    this.storage = storage_1.default[selectedEngine.type](selectedEngine.name);
                }
                else {
                    this.storage = storage_1.default[selectedEngine.type];
                }
            }
            this.storage = (_a = props === null || props === void 0 ? void 0 : props.storage) !== null && _a !== void 0 ? _a : this.defaultStorage;
        }
        else {
            this.storage = this.defaultStorage;
        }
        // assign modifier functions (transforms) if any
        if ((_b = props === null || props === void 0 ? void 0 : props.transforms) === null || _b === void 0 ? void 0 : _b.length) {
            this.transforms = props === null || props === void 0 ? void 0 : props.transforms;
        }
        // bind encrypt
        this.encrypt = props === null || props === void 0 ? void 0 : props.encrypt;
    }
    return Cella;
}());
exports.default = Cella;
